//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/public'
export default {
    data () {
        return {
            show_operate: true
        }
    },
    methods: {
        getPhoneNum (e) {
            const { iv, encryptedData, errMsg } = e.target
            const { code } = e.detail
            Service.postWeixinPhone(iv, encryptedData, errMsg, { code }).then((data) => {
                if (Number(data.code) === 422) {
                    wx.showToast({
                        title: data.error_message,
                        icon: 'none'
                    })
                } else {
                    Service.addConsultantClient(this.consultant_id)
                    this.hideOperate()
                }
            })
        },
        hideOperate () {
            this.show_operate = false
        }
    },
    props: {
        msg: {
            type: Object
        },
        consultant_id: {
            type: Number
        }
    }
}
